import { render, staticRenderFns } from "./RiskAddress.vue?vue&type=template&id=73767ecb"
import script from "./RiskAddress.vue?vue&type=script&lang=ts"
export * from "./RiskAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports